/**
 * @desc 爬虫详情
 */
const URL = "/rantion-crawler";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/crawler/getDetail/${id}`, {
      method: "POST",

      ...options,
    }),
  );
}
